import { render, staticRenderFns } from "./JudgementListSlotLeft.vue?vue&type=template&id=a7971168&scoped=true&"
import script from "./JudgementListSlotLeft.vue?vue&type=script&lang=ts&"
export * from "./JudgementListSlotLeft.vue?vue&type=script&lang=ts&"
import style0 from "./JudgementListSlotLeft.vue?vue&type=style&index=0&id=a7971168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7971168",
  null
  
)

export default component.exports